import { app } from '../../app';
import { Controller } from './sp-group-type.controller';

app.component('spGroupType', {
    bindings: {
        groupType: '<',
        hideIcon: '<',
        tooltipPlacement: '@',
    },
    controller: Controller,
    templateUrl: require('./sp-group-type.html'),
});



// WEBPACK FOOTER //
// ./src/portal/components/sp-group-type/sp-group-type.component.js